import { defineComponent as _defineComponent } from 'vue'

  import Modal from "@/components/ui/Modal.vue";

  interface Data {
    firstName: string;
    email: string;
  }
  interface Props {
    isOpen: boolean;
    data: Data;
  }
  
export default /*@__PURE__*/_defineComponent({
  __name: 'CheckEmailModal',
  props: {
    data: {}
  },
  emits: ["close"],
  setup(__props: any, { expose: __expose, emit: __emit }) {
  __expose();

  const emits = __emit;

  const props = __props;

  function onClose() {
    emits("close");
  }

const __returned__ = { emits, props, onClose, Modal }
Object.defineProperty(__returned__, '__isScriptSetup', { enumerable: false, value: true })
return __returned__
}

})